package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.finance.AdjustmentDto
import com.evoapps.evoshift.data.dto.finance.AdjustmentTypeDto
import com.evoapps.evoshift.domain.model.Adjustment
import com.evoapps.evoshift.domain.model.AdjustmentType

class AdjustmentMapper(
    private val metadataMapper: MetadataMapper
) {

    fun toDomain(dto: AdjustmentDto): Adjustment {
        return Adjustment(
            id = dto.id,
            userId = dto.userId,
            rosterId = dto.rosterId,
            type = when (dto.type) {
                AdjustmentTypeDto.BONUS -> AdjustmentType.BONUS
                AdjustmentTypeDto.DEDUCTION -> AdjustmentType.DEDUCTION
                AdjustmentTypeDto.EXPENSE_REFUND -> AdjustmentType.EXPENSE_REFUND
            },
            amount = dto.amount,
            currency = dto.currency,
            description = dto.description,
            date = dto.date,
            relatedShiftId = dto.relatedShiftId,
            metadata = metadataMapper.toDomain(dto.metadata)
        )
    }

    fun toDto(domain: Adjustment): AdjustmentDto {
        return AdjustmentDto(
            id = domain.id,
            rosterId = domain.rosterId,
            userId = domain.userId,
            type = when (domain.type) {
                AdjustmentType.BONUS -> AdjustmentTypeDto.BONUS
                AdjustmentType.DEDUCTION -> AdjustmentTypeDto.DEDUCTION
                AdjustmentType.EXPENSE_REFUND -> AdjustmentTypeDto.EXPENSE_REFUND
            },
            amount = domain.amount,
            currency = domain.currency,
            date = domain.date,
            description = domain.description,
            relatedShiftId = domain.relatedShiftId,
            metadata = metadataMapper.toDto(domain.metadata)
        )
    }
}
